<template>
    <div class="help-container">
        <div class="img-container">
            <img src="../assets/img/01.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/02.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/03.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/04.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/05.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/06.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/07.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/08.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/09.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/10.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/11.png" alt class="col-img"/>
        </div>
        <div class="img-container">
            <img src="../assets/img/12.png" alt class="col-img"/>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {};
    }
  };
</script>
<style lang="scss" scoped>
    .help-container {
        padding: 10px;
        margin-top: 130px;
        min-height: 100%;
    }

    .img-container {
        width: 90%;
        margin: 5px auto;
        box-sizing: border-box;
        overflow: hidden;
    }

    .img-container img {
        height: 100%;
        width: 100%;
        display: block;
    }

    .col-img {
        transform: scale(1.1)
    }
</style>



// WEBPACK FOOTER //
// src/components/help.vue